// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only.

import type { ReactNode } from 'react'
import Alert from '@mui/material/Alert'

/** D-UI-3 — an inline banner (stale data, a failed save inside a dialog). Loading/empty/failed lists use LoadState. */
export default function Notice({ severity = 'info', children }: { severity?: 'info' | 'warning' | 'error' | 'success'; children: ReactNode }) {
  return <Alert severity={severity} sx={{ mb: 2 }}>{children}</Alert>
}
